import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ProductSelector } from '../ProductSelector '; 
import { useNavigate } from 'react-router-dom';
import { ProductSelectorWrapper } from '../ProductSelectorWrapper';

const ProductMatchDialog = ({ show, onHide, onCompare  }) => {
  const [comparisonType, setComparisonType] = useState('single'); // 'single' or 'compare'
  const [selected1, setSelected1] = useState(null);
  const [selected2, setSelected2] = useState(null);
  const navigate = useNavigate();

  // For single-product match, communicate with backend and route to result page
  const handleProductResult = async (selectedProduct) => {
    if (!selectedProduct?.shadeHex) return;
    try {
      const response = await fetch("https://makeupmatch.onrender.com/match-by-hex", {  
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ hex: selectedProduct.shadeHex })
      });
      const data = await response.json();
      // Route to result page, pass product + matches + lab
      navigate('/colormatch/product-match-result', {
        state: {
          product: selectedProduct,
          matches: data.matches,
          lab: data.lab
        }
      });
      onHide();
    } catch (error) {
      console.error("Product match API error:", error);
    }
  };

  // Handle modal submit
  const handleSubmit = () => {
    if (comparisonType === 'compare') {
      if (onCompare) {
        onCompare(selected1, selected2); // instead of onSubmit
    }
    } else {
      handleProductResult(selected1);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Match by Product</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Check
              type="radio"
              label="Find matches for one product"
              name="matchType"
              checked={comparisonType === 'single'}
              onChange={() => setComparisonType('single')}
            />
            <Form.Check
              type="radio"
              label="Compare two products"
              name="matchType"
              checked={comparisonType === 'compare'}
              onChange={() => setComparisonType('compare')}
            />
          </Form.Group>

          {comparisonType === 'single' && (
            <ProductSelector onChange={setSelected1} />
          )}

          {comparisonType === 'compare' && (
            <div className="d-flex flex-row gap-3">
              <div style={{ flex: 1 }}>
                <ProductSelectorWrapper onSelection={setSelected1} />
              </div>
              <div style={{ flex: 1 }}>
                <ProductSelectorWrapper onSelection={setSelected2} />
              </div>
            </div>
          )}

        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          style={{background:"#7D7ABC"}}
          onClick={handleSubmit}
          disabled={
            (comparisonType === 'single' && !selected1) ||
            (comparisonType === 'compare' && (!selected1 || !selected2))
          }
        >
          {comparisonType === 'compare' ? 'Compare' : 'Find Matches'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProductMatchDialog;
